export default class Timetable {
    constructor(firebaseDb) {
        this.firebaseDb = firebaseDb;
        this.activeRefs = [];
    }

    isAvailable(eventId, stageId, callback) {
        const ref = this.firebaseDb.ref(`timetable/${eventId}/${stageId}`);

        ref.once('value').then((snapshot) => {
            if (null !== snapshot.val()) {
                callback(true);
            } else {
                this.activeRefs.push(ref);
                ref.on('value', (snapshot) => {
                    if (null !== snapshot.val()) {
                        callback(true);
                    } else {
                        callback(false);
                    }
                });
            }
        });
    }

    stopCheckingAvailability() {
        this.activeRefs.forEach((ref, key) => {
            if (undefined !== ref) {
                ref.off();
                this.activeRefs[key] = undefined;
            }
        });
    }

    listen(_eventId, _stageId, callback) {
        const ref = this.firebaseDb.ref(`timetable/${_eventId}/${_stageId}`);

        ref.on('value', (snapshot) => {
            let value = snapshot.val();
            if (null !== value) {
                if (value.data !== undefined && value.data !== null) {
                    callback(value.data);
                }
            }
        });

        return () => {
            ref.off();
        }
    }

    async fetchCurrentTimetableHeat(_eventId, _stageId) {
        const snapshot = await this.firebaseDb.ref(`timetable/${_eventId}/${_stageId}`).once('value');
        const firebaseData = snapshot.val();

        if (undefined !== firebaseData && null !== firebaseData && undefined !== firebaseData.selected) {
            if (undefined !== firebaseData.selected.heat) {
                const selected = firebaseData.selected.heat;
                const dateData = firebaseData.data[selected.date];
                if (!dateData || !dateData.rounds) return null;

                const roundData = dateData.rounds[selected.round];
                if (!roundData || !roundData.heats) return null;
                const heatData = roundData.heats[selected.key];

                const isDouble = selected.isDouble === true || (
                    undefined !== selected.round2 && null !== selected.round2 &&
                    undefined !== selected.key2 && null !== selected.key2
                );

                if (isDouble) {
                    const roundData2 = dateData.rounds[selected.round2];
                    const heatData2 = roundData2 ? roundData2.heats[selected.key2] : null;

                    return {
                        isDouble: true,
                        slotA: {
                            title: roundData.discipline || roundData.title || "",
                            heat: heatData,
                            heat_nr: heatData ? `${heatData.id}/${roundData.heats.length}` : "",
                        },
                        slotB: {
                            title: roundData2 ? (roundData2.discipline || roundData2.title || "") : "",
                            heat: heatData2,
                            heat_nr: (heatData2 && roundData2) ? `${heatData2.id}/${roundData2.heats.length}` : "",
                        }
                    };
                }

                return {
                    isDouble: false,
                    title: roundData.discipline || roundData.title || "",
                    heat: heatData,
                    heat_nr: heatData ? `${heatData.id}/${roundData.heats.length}` : "",
                };
            }
        }

        return null;
    }

    listenCurrentHeat(_eventId, _stageId, callback) {
        const ref = this.firebaseDb.ref(`timetable/${_eventId}/${_stageId}`);

        ref.on('value', (snapshot) => {
            const firebaseData = snapshot.val();

            if (undefined !== firebaseData && null !== firebaseData && undefined !== firebaseData.selected) {
                if (undefined !== firebaseData.selected.heat) {
                    const selected = firebaseData.selected.heat;
                    const dateData = firebaseData.data[selected.date];
                    if (!dateData || !dateData.rounds) {
                        callback(null);
                        return;
                    }

                    const roundData = dateData.rounds[selected.round];
                    if (!roundData || !roundData.heats) {
                        callback(null);
                        return;
                    }
                    const heatData = roundData.heats[selected.key];

                    const isDouble = selected.isDouble === true || (
                        undefined !== selected.round2 && null !== selected.round2 &&
                        undefined !== selected.key2 && null !== selected.key2
                    );

                    if (isDouble) {
                        const roundData2 = dateData.rounds[selected.round2];
                        const heatData2 = roundData2 ? roundData2.heats[selected.key2] : null;

                        callback({
                            isDouble: true,
                            slotA: {
                                title: roundData.discipline || roundData.title || "",
                                heat: heatData,
                                heat_nr: heatData ? `${heatData.id}/${roundData.heats.length}` : "",
                            },
                            slotB: {
                                title: roundData2 ? (roundData2.discipline || roundData2.title || "") : "",
                                heat: heatData2,
                                heat_nr: (heatData2 && roundData2) ? `${heatData2.id}/${roundData2.heats.length}` : "",
                            }
                        });
                        return;
                    }

                    callback({
                        isDouble: false,
                        title: roundData.discipline || roundData.title || "",
                        heat: heatData,
                        heat_nr: heatData ? `${heatData.id}/${roundData.heats.length}` : "",
                    });
                    return;
                }
            }

            callback(null);
        });

        return () => {
            ref.off();
        };
    }
}